export default {
    actions: {
      async apiRequest({ getters }, { endpoint, method = "GET", data = null, headers = {} }) {
        let response;
        try {
          let fullurl = getters.url + endpoint;
          if (method === "GET") {
            response = await fetch(fullurl, {
              method: "GET",
              headers: headers,
            });
          } else if (method === "POST") {
            response = await fetch(fullurl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                ...headers,
              },
              body: JSON.stringify(data),
            });
          } else {
            throw new Error("Неподдерживаемый метод запроса");
          }
        } catch (e) {
          // console.log(e);
          throw new Error("Нет соединения с сервером");
        }
        return await response;
      },
    },
    getters: {
      url() {
        return '/api/v1/webgui/'
      }
    }
  }
